import { STATUS_LABELS, TYPE_LABELS, type GvmRecord, type Status } from '../lib/types';

export function statusVarName(status: Status): string {
  return `--status-${status}`;
}

export function statusDot(status: Status): string {
  return `<span class="status-dot" style="background:var(${statusVarName(status)})"></span>`;
}

export function badge(text: string): string {
  return `<span class="badge">${escapeHtml(text)}</span>`;
}

export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c] as string));
}

export function formatDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function recordRowHtml(r: GvmRecord): string {
  const meta = [TYPE_LABELS[r.type], r.owner || null, r.execution_lane || null]
    .filter(Boolean)
    .join(' · ');
  return `
    <a href="#/record/${encodeURIComponent(r.id)}" class="card tap record-row" style="text-decoration:none; display:flex;">
      ${statusDot(r.status)}
      <div class="body">
        <div class="title">${escapeHtml(r.title)}</div>
        <div class="meta">
          ${badge(STATUS_LABELS[r.status])}
          ${meta ? `<span>${escapeHtml(meta)}</span>` : ''}
          ${r.next_action ? `<span>→ ${escapeHtml(r.next_action)}</span>` : ''}
        </div>
      </div>
      <div class="score">${r.overall_score.toFixed(1)}</div>
    </a>
  `;
}

let toastTimer: number | undefined;
export function showToast(message: string, kind: 'success' | 'error' = 'success'): void {
  let el = document.getElementById('gvm-toast');
  if (!el) {
    el = document.createElement('div');
    el.id = 'gvm-toast';
    document.body.appendChild(el);
  }
  el.className = `toast ${kind}`;
  el.textContent = message;
  el.style.display = 'block';
  window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => { el!.style.display = 'none'; }, 3200);
}

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  children: (Node | string)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) node.setAttribute(k, v);
  for (const c of children) node.append(c);
  return node;
}
